module.exports = __webpack_public_path__ + "img/logoBlack.1cf84835.svg";